import React, { Component } from 'react';
import styles from './ReportsPage.module.scss';
import { ReactComponent as LandingSyncSvg } from '../../../resources/images/landing-sync.svg';
import { ReactComponent as LandingSetupSvg } from '../../../resources/images/landing-setup.svg';
import { ReactComponent as LandingReportsSvg } from '../../../resources/images/landing-reports.svg';
import LayoutComponent from '../../../components/LayoutComponent/LayoutComponent';
import Icon from '@ant-design/icons';
import CustomContext from '../../../context/CustomContext';
import { FormattedMessage, injectIntl, WrappedComponentProps } from 'react-intl';
import { Col, Row } from 'antd';
import { Link } from 'react-router-dom';

class ReportsPage extends Component<Props> {
    static contextType = CustomContext;
    context!: React.ContextType<typeof CustomContext>;

    /*** COMPONENTS ***/

    render() {
        return (
            <LayoutComponent pageId="reports">
                <Row justify="start" align="stretch" gutter={[52, 30]}>
                    <Col xs={24} md={12} lg={6}>
                        <div className={`${styles.report} ${styles.disabled}`}>
                            <Icon component={LandingSyncSvg} className={styles.image} />
                            <p className={styles.title}>
                                <FormattedMessage id="reports.checklistDetails" />
                            </p>
                            <p className={styles.description}>
                                <FormattedMessage id="reports.checklistDetails.description" />
                            </p>
                        </div>
                    </Col>
                    <Col xs={24} md={12} lg={6}>
                        <div className={`${styles.report} ${styles.disabled}`}>
                            <Icon component={LandingSetupSvg} className={styles.image} />
                            <p className={styles.title}>
                                <FormattedMessage id="reports.issues" />
                            </p>
                            <p className={styles.description}>
                                <FormattedMessage id="reports.issues.description" />
                            </p>
                        </div>
                    </Col>
                    <Col xs={24} md={12} lg={6}>
                        <Link to="/reports/design-ratings">
                            <div className={styles.report}>
                                <Icon component={LandingReportsSvg} className={styles.image} />
                                <p className={styles.title}>
                                    <FormattedMessage id="reports.designRating" />
                                </p>
                                <p className={styles.description}>
                                    <FormattedMessage id="reports.designRating.description" />
                                </p>
                            </div>
                        </Link>
                    </Col>
                </Row>
            </LayoutComponent>
        );
    }
}
export default injectIntl(ReportsPage);

interface Props extends WrappedComponentProps {}
